$(document).ready(function() {
    Handlebars.registerHelper('getHeatLevelImage', getHeatLevelImage);
    fetchProductDetails(blendData.blends);
    initializeSlick();

    registerHandlers();
});

function fetchProductDetails(blends) {
  var detailsArray = [];
  var requests = [];
  var dictionary = {};

  for (var i = 0; i < blends.length; i++) {
    var request = $.getJSON(window.Shopify.routes.root + 'products/' + blends[i].handle + '.js', function(data) {
      detailsArray.push(data);
    });
    
    requests.push(request);
    dictionary[blends[i].handle] = { request: request, blend: blends[i]};
  }
  
  $.when.apply($, requests).then(function(results) {
    var d = detailsArray;

    for (var i = 0; i < detailsArray.length; i++) {
      var dictionaryEntry = dictionary[detailsArray[i].handle];

      if (dictionaryEntry != null) {
        dictionaryEntry.blend.isAvailable = detailsArray[i].available;
      }
    }
  });
}

function initializeSlick() {
  $('.step-container').slick({
      arrows: false,
      draggable: false,
      mobileFirst: true,
      swipe: false,
      touchMove: false,
      adaptiveHeight: true
  });
}

function registerHandlers() {
    $('[data-retake-quiz-btn]').click(function() {
        resetQuiz();
    });

    $('.next-step').click(function(e) {
      $('.extra-sections').hide();
      $('.step-container').slick('slickNext');
      window.scrollTo(0, 0);
    });

    $('#btnShowMyResults').click(showResultsClickHandler);

    $('.quiz-button[data-food-type]').click(foodTypeClickHandler);

    $('.quiz-button[data-flavor-type]').click(flavorTypeClickHandler);

    $('#addAllToCart').click(addAllToCart);

    $('.btn-build').click(btnBuildHandler);
}

function btnBuildHandler(e) {
  var url = $(e.currentTarget).data('url');
  var results = computeResults(blendData.blends);
  results = underscore.sortBy(results, 'rank');
  
  if (results == null || results.length == 0) {
    return;
  }
  
  var blendNames = [];
  results.forEach(function(blend) {
    if (blend.isAvailable) {
      blendNames.push(blend.name);
    }
  });

  var encoded = encodeURIComponent(blendNames);

  window.location.href = url + '?blends=' + encoded;
}

function addAllToCart() {
  var results = computeResults(blendData.blends);

  if (results == null || results.length == 0) {
    return;
  }

  var items = [];

  results.forEach(function(blend) {
    if (blend.isAvailable) {
      items.push({ id: blend.variantId, quantity: 1 });
    }
  });

  $.ajax({
    type: 'post',
    url: window.Shopify.routes.root + 'cart/add.js',
    data: { items: items },
    dataType: 'text',
    success: function(data) {
      window.SLIDECART_UPDATE(function() {
        window.SLIDECART_OPEN();
      });
    },
    error: function(jqXhr, textStatus, errorThrown) {
      alert('Sorry, these products could not be added to your cart at this time.');
    }
  });
}

function getHeatLevelImage(heatLevel) {
    switch (heatLevel) {
        case 0:
            return new Handlebars.SafeString("https://cdn.shopify.com/s/files/1/2561/1616/files/heat-scale-none-x700.png?v=1614302169");
        case 1:
            return new Handlebars.SafeString("https://cdn.shopify.com/s/files/1/2561/1616/files/heat-scale-mild-x700.png?v=1614302169");
        case 2:
            return new Handlebars.SafeString("https://cdn.shopify.com/s/files/1/2561/1616/files/heat-scale-medium-x700.png?v=1614302169");
        case 3:
            return new Handlebars.SafeString("https://cdn.shopify.com/s/files/1/2561/1616/files/heat-scale-hot-x700.png?v=1614302168");
    }
}

function showResultsClickHandler(e) {
    // 1. get ones that are sweet or savory
    // 2. get ones that are less than or at our heat level
    // 3. must match at least one of their food categories

    var results = computeResults(blendData.blends);
    results = underscore.sortBy(results, 'rank');

    fetchProductDetails(results);

    var seasonalBlends = underscore.where(results, { isSeasonal: true });
    var activeBlends = underscore.filter(results, function(elem) {
          return elem.isSeasonal == undefined || elem.isSeasonal == false || elem.isSeasonalActive == true;
      });
  
    var template = $('#quizResultsTemplate').html();
    var templateFunc = Handlebars.compile(template);
    var templateInstance = templateFunc({ activeBlends: activeBlends, seasonalBlends: seasonalBlends });
    $('.results-container').html(templateInstance);
  
    if (results.length > 0) {
      $('#hasResultsContainer').show();
      $('#noResultsContainer').hide();
    } else {
      $('#hasResultsContainer').hide();
      $('#noResultsContainer').show();
    }
  
    $('.step-container').hide();
    $('#quizRecommendations').slideDown(900, function() {
      $('.extra-sections').show();
    });
}

function foodTypeClickHandler(e) {
    var $target = $(e.currentTarget);

    if ($target.data('selected') == true) {
        $target.removeClass('selected');
        $target.data('selected', false);
    } else {
        $target.addClass('selected');
        $target.data('selected', true);
    }

    // User can proceed if at least one food type has been selected
    var $btnShowResults = $('#btnShowMyResults');

    if ($('.foods-wrapper .quiz-button.selected').length > 0) {
        // enable
        $btnShowResults.removeAttr('disabled');
        $btnShowResults.addClass('valid');
        $btnShowResults.text('Show my results!')
    } else {
        // disable
        $btnShowResults.attr('disabled', 'disabled');
        $btnShowResults.removeClass('valid');
        $btnShowResults.text('Make selection');
    }
}

function flavorTypeClickHandler(e) {
    var $newSelection = $(e.currentTarget);
        var $oldSelection = null;

        if ($newSelection.data('flavor-type') == 'sweet') {
            $oldSelection = $('[data-flavor-type=savory]')
        } else {
            $oldSelection = $('[data-flavor-type=sweet]')
        }

    // if already selected, no-op
    if ($newSelection.data('selected') == true) {
        return;
    };

    // switching choices
    $newSelection.addClass('selected');
    $newSelection.data('selected', true);
    $oldSelection.removeClass('selected');
    $oldSelection.data('selected', false);
}

function computeResults(blends) {
    var heatLevel = 0;
    var spiceLevelInputValue = $('#spice-level').val();

    switch (spiceLevelInputValue) {
        case '0':
            heatLevel = 0;
            break;
        case '1':
            heatLevel = 1;
            break;
        case '2':
            heatLevel = 2;
            break;
        case '3':
            heatLevel = 3;
    }
    
    var isSweet = $('.selected[data-flavor-type]').data('flavor-type') == 'sweet';

    var $selectedFoodTypeElems = $('[data-food-type].selected');
    var selectedFoodTypes = [];

    $selectedFoodTypeElems.each(function(index, val) {
        var foodTypeStr = $(val).data('food-type');
        var foodTypeEnumVal = null;

        switch(foodTypeStr) {
            case 'red-meat':
                foodTypeEnumVal = FoodEnums.RED_MEAT;
                break;
            case 'pork':
                foodTypeEnumVal = FoodEnums.PORK;
                break;
            case 'poultry':
                foodTypeEnumVal = FoodEnums.POULTRY;
                break;
            case 'veggies':
                foodTypeEnumVal = FoodEnums.VEGGIES;
                break;
            case 'fruit':
                foodTypeEnumVal = FoodEnums.FRUIT;
                break;
            case 'seafood':
                foodTypeEnumVal = FoodEnums.SEAFOOD;
                break;
            case 'all-use':
                foodTypeEnumVal = FoodEnums.ALL_USE;
                break;
        }

        if (foodTypeEnumVal != null) {
            selectedFoodTypes.push(foodTypeEnumVal);
        }
    });

    // filter by heat
    var results = filterByHeat(blends, heatLevel);

    // filter by sweet or savory
    results = filterByFlavorType(results, isSweet);

    // filter by food categories
    results = filterByFoodType(results, selectedFoodTypes)

    return results;
}

function filterByFoodType(blends, foodTypes) {
    var matchedBlends = [];

    blends.forEach(function (blend, index) {
        var isMatch = foodTypes.some(r=> blend.pairings.indexOf(r) >= 0)

        if (isMatch) {
            matchedBlends.push(blend);
        }
    });

    return matchedBlends;
}

function filterByFlavorType(blends, isSweet) {
    var matches = underscore.where(blends, { isSweet: isSweet });

    return matches;
}

function filterByHeat(blends, heatLevel) {
    var heatMatches = underscore.filter(blends, function(elem) {
        return elem.heat <= heatLevel;
    });

    return heatMatches;
}

function resetQuiz() {
    var $btnShowResults = $('#btnShowMyResults');
    $btnShowResults.attr('disabled', 'disabled');
    $btnShowResults.removeClass('valid');
    $btnShowResults.text('Make selection');

    var $selectedFoodTypes = $('[data-food-type].selected');
    $selectedFoodTypes.removeClass('selected');
    $selectedFoodTypes.data('selected', false);

    $('[data-flavor-type=savory]').removeClass('selected');
    $('[data-flavor-type=savory]').data('selected', false);
    $('[data-flavor-type=sweet]').addClass('selected');
    $('[data-flavor-type=sweet]').data('selected', true);

    $('#hasResultsContainer').show();
    $('#noResultsContainer').hide();

    $('#spice-level').val(2);
    $('.results-container').html('');

    window.scrollTo(0, 0);

    //$('.step-container').slick('slickGoTo', 0, true);

    $('.step-container').slick('destroy');

    $('.step-container').show();
    $('.extra-sections').show();
    $('#quizRecommendations').hide();

    initializeSlick();
}

var FoodEnums = {
    RED_MEAT: 1,
    PORK: 2,
    POULTRY: 3,
    VEGGIES: 4,
    ALL_USE: 5,
    FRUIT: 6,
    SEAFOOD: 7
};

var blendData = {
        blends: [
          {
                name: 'Battle Beard',
                description: "Brown Sugar Bourbon",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Battle-Beard.jpg?v=1693445714",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: true,
                url: '/collections/blends/products/battle-beard',
                handle: 'battle-beard',
                variantId: 43938638725356,
                isAvailable: true,
                rank: 3
          },  
          {
                name: 'Battle Buddy',
                description: "All Purpose",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Battle-Buddy_6ce7c81e-f41c-411e-b08a-fa823ab41cb9.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: false,
                url: '/collections/blends/products/battle-buddy',
                handle: 'battle-buddy',
                variantId: 9542317735978,
                isAvailable: true,
                rank: 3
            },
            {
                name: 'Blackout',
                description: "Blackened Seasoning",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Blackout_9a64ce9f-b9ea-4394-90d0-4e7dac08d174.jpg?v=1614655121",
                heat: 2,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: false,
                url: '/collections/blends/products/blackout',
                handle: 'blackout',
                variantId: 9543189233706,
                isAvailable: false,
                isSeasonal: true,
                isSeasonalActive: false,
                rank: -1
            },
            {
                name: 'Blue Line',
                description: "Lime Pepper",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Blue-Line_c4b84120-d536-4889-b531-d704340865f3.jpg?v=1614655121",
                heat: 1,
                pairings: [FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.SEAFOOD],
                isSweet: true,
                url: '/collections/blends/products/blue-line',
                handle: 'blue-line',
                variantId: 9542403948586,
                isAvailable: true,
                rank: 10
            },
            {
                name: 'Bunker Buster',
                description: "Steak & Wild Game",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Bunker-Buster_c0d9d24f-4c26-4e74-9f68-729b9abe08e5.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE],
                isSweet: true,
                url: '/collections/blends/products/bunker-buster',
                handle: 'bunker-buster',
                variantId: 33411312812120,
                isAvailable: true,
                rank: 6
            },
            {
                name: 'Chem Ops',
                description: "Savory Rub",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Chem-Ops_f7106abe-00e3-46f6-b310-cf26546d2224.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.SEAFOOD],
                isSweet: false,
                url: '/collections/blends/products/chem-ops',
                handle: 'chem-ops',
                variantId: 37861397659828,
                isAvailable: true,
                rank: 11
            },
            {
                name: 'Combat Canary',
                description: "Poultry Seasoning",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Combat-Canary_280c3d66-808c-4148-9a87-2dbb5663ce89.jpg?v=1614655121",
                heat: 2,
                pairings: [FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE],
                isSweet: false,
                url: '/collections/blends/products/combat-canary',
                handle: 'combat-canary',
                variantId: 9541990547498,
                isAvailable: true,
                rank: 13
            },
            {
                name: 'Constitution',
                description: "Sweet & Smoky",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Constitution_b21fee06-8eae-4a82-8dfc-8ef3209de074.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES],
                isSweet: true,
                url: '/collections/blends/products/constitution',
                handle: 'constitution',
                variantId: 33411312844888,
                isAvailable: true,
                rank: 2
            },
            {
                name: 'Fatty Cake',
                description: 'Chocolate Cake',
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Fatty-Cake_571761b3-f0f8-4818-b437-bbaaeb8da58b.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.FRUIT],
                isSweet: true,
                url: '/collections/blends/products/fatty-cake',
                handle: 'fatty-cake',
                variantId: 9540655841322,
                isAvailable: false,
                isSeasonal: true,
                isSeasonalActive: false,
                rank: -1
            },
            {
                name: 'Fitty',
                description: "Mango Habanero",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Fitty_fed48765-0f71-47d9-b676-866e4bf67f7f.jpg?v=1614655121",
                heat: 3,
                pairings: [FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES],
                isSweet: true,
                url: '/collections/blends/products/fitty',
                handle: 'fitty',
                variantId: 8481613709354,
                isAvailable: true,
                rank: 8
            },
            {
                name: 'Freedom Spice',
                description: "Honey BBQ",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Freedom-Spice_2bbf4902-5569-4f05-9864-7f8e1f65ee32.jpg?v=1614655121",
                heat: 1,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES],
                isSweet: true,
                url: '/collections/blends/products/freedom-spice',
                handle: 'freedom-spice',
                variantId: 33411312975960,
                isAvailable: true,
                rank: 5
            },
            {
                name: 'Husky',
                description: "Taco Seasoning",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Husky_fabb5462-e02b-43c7-9119-669fa9a5f83b.jpg?v=1673034199",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.ALL_USE],
                isSweet: false,
                url: '/collections/blends/products/husky',
                handle: 'husky',
                variantId: 9542144294954,
                isAvailable: true,
                isSeasonal: true,
                isSeasonalActive: true,
                rank: -1
            },
            {
                name: 'Liberator',
                description: "Lemon Garlic",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Liberator_c70a2e2e-a2b4-48c7-8a7f-fb263ece0690.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.SEAFOOD, FoodEnums.ALL_USE],
                isSweet: false,
                url: '/collections/blends/products/liberator',
                handle: 'liberator',
                variantId: 9541743312938,
                isAvailable: true,
                rank: 14
            },
            {
                name: 'Medic',
                description: "Jamaican Jerk",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Medic_60c5b1ed-5651-4173-9e04-de71eb16f980.jpg?v=1614655121",
                heat: 2,
                pairings: [FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: true,
                url: '/collections/blends/products/medic',
                handle: 'medic',
                variantId: 9542800769066,
                isAvailable: true,
                rank: 15
            },
            {
                name: '\'Merica',
                description: "Wing Seasoning",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Merica.jpg?v=1673544213",
                heat: 0,
                pairings: [FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES],
                isSweet: true,
                url: '/collections/blends/products/merica',
                handle: 'merica',
                variantId: 9542558154794,
                isAvailable: false,
                isSeasonal: true,
                isSeasonalActive: false,
                rank: -1
            },
            {
                name: 'Operator',
                description: "Red Hickory Smoke",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Operator_a0a8985b-d63e-4bb7-a590-c0ee278dbd5e.jpg?v=1614655121",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.POULTRY, FoodEnums.SEAFOOD],
                isSweet: false,
                url: '/collections/blends/products/operator',
                handle: 'operator',
                variantId: 33411313172568,
                isAvailable: true,
                rank: 7
              
            },
            {
                name: 'Reaper',
                description: "Reaper Laced Blend",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Reaper_c1ecc4d6-60f7-4073-adfd-6dd2ce00fa29.jpg?v=1614655121",
                heat: 3,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE],
                isSweet: false,
                url: '/collections/blends/products/reaper',
                handle: 'reaper',
                variantId: 9541080678442,
                isAvailable: true,
                isSeasonal: true,
                isSeasonalActive: true,
                rank: -1
            },
            {
                name: 'Red Line',
                description: "Honey Chipotle",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Red-Line_927ae15b-a6eb-421c-853f-89bd2027e0ee.jpg?v=1614655121",
                heat: 2,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: true,
                url: '/collections/blends/products/red-line',
                handle: 'red-line',
                variantId: 9541264769066,
                isAvailable: true,
                rank: 12
            },
            {
                name: 'Ranch Ranger',
                description: "Ranch Seasoning",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Ranch_Ranger.jpg?v=1673543939",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: false,
                url: '/collections/blends/products/ranch-ranger',
                handle: 'ranch-ranger',
                variantId: 9543498432554,
                isAvailable: false,
                isSeasonal: true,
                isSeasonalActive: false,
                rank: -1
            },
            {
                name: 'Salty SGT',
                description: "Salty Steak & Burger",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Salty-SGT_ca8b9b94-3daa-431a-81f6-97ce4e8b1b4e.jpg?v=1614655120",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE],
                isSweet: false,
                url: '/collections/blends/products/salty-sgt',
                handle: 'salty-sgt',
                variantId: 33411313762392,
                isAvailable: true,
                rank: 1
            },
            {
                name: 'Shellshock',
                description: "Spicy Maple Bacon",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Shellshock_4929202c-f45e-4c5a-964b-3ddd9fa594f6.jpg?v=1614655121",
                heat: 3,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE],
                isSweet: true,
                url: '/collections/blends/products/shellshock',
                handle: 'shellshock',
                variantId: 33411313827928,
                isAvailable: true,
                rank: 9
            },
            {
                name: 'Soul Snatcher',
                description: "Nashville Hot",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/SoulSnatcher.jpg?v=1698419575",
                heat: 2,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE, FoodEnums.SEAFOOD],
                isSweet: true,
                url: '/collections/blends/products/soul-snatcher',
                handle: 'soul-snatcher',
                variantId: 44008792391916,
                isAvailable: true,
                rank: 4
            },
            {
                name: 'Warthog',
                description: "Maple Bacon",
                img: "https://cdn.shopify.com/s/files/1/2561/1616/files/Warthog.jpg?v=1720712108",
                heat: 0,
                pairings: [FoodEnums.RED_MEAT, FoodEnums.PORK, FoodEnums.POULTRY, FoodEnums.VEGGIES, FoodEnums.ALL_USE],
                isSweet: true,
                url: '/collections/blends/products/warthog',
                handle: 'warthog',
                variantId: 33411313303640,
                isAvailable: true,
                rank: 4
            }
        ]
    };